export default __webpack_public_path__ + "static/media/Group20.e402f42e.png";